"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoUpload = exports.videoTypeUpload = exports.videoTypeListAll = exports.videoTypeList = exports.videoTypeDelete = exports.videoList = exports.videoDeletePut = exports.videoDelete = exports.courseProjectUpload = exports.courseProjectListAll = exports.courseProjectList = exports.courseProjectDelete = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 课程公开课 分页查询
var videoList = exports.videoList = function videoList(data) {
  return _api.default.request({
    url: '/videoOpenClass/getList',
    method: 'post',
    data: data
  });
};

// 课程公开课 新增/编辑
var videoUpload = exports.videoUpload = function videoUpload(data) {
  return _api.default.request({
    url: '/videoOpenClass/insertOrUpdate VideoOpenClass',
    method: 'post',
    data: data
  });
};

// 课程公开课 删除
var videoDelete = exports.videoDelete = function videoDelete(data) {
  return _api.default.request({
    url: '/videoOpenClass/delete VideoOpenClass',
    method: 'post',
    data: data
  });
};

// 课程公开课 上下架
var videoDeletePut = exports.videoDeletePut = function videoDeletePut(data) {
  return _api.default.request({
    url: '/videoOpenClass/updateIsPut',
    method: 'post',
    data: data
  });
};

// 数字课程项目管理 查询全部
var courseProjectListAll = exports.courseProjectListAll = function courseProjectListAll(data) {
  return _api.default.request({
    url: '/courseProject/getListAll',
    method: 'post',
    data: data
  });
};

// 数字课程项目管理 分页查询
var courseProjectList = exports.courseProjectList = function courseProjectList(data) {
  return _api.default.request({
    url: '/courseProject/getList',
    method: 'post',
    data: data
  });
};

// 数字课程项目管理 新增/编辑
var courseProjectUpload = exports.courseProjectUpload = function courseProjectUpload(data) {
  return _api.default.request({
    url: '/courseProject/insertOrUpdateCourseProject',
    method: 'post',
    data: data
  });
};

// 数字课程项目管理 删除
var courseProjectDelete = exports.courseProjectDelete = function courseProjectDelete(data) {
  return _api.default.request({
    url: '/courseProject/deleteCourseProject',
    method: 'post',
    data: data
  });
};

// 视频分类管理 查询全部
var videoTypeListAll = exports.videoTypeListAll = function videoTypeListAll(data) {
  return _api.default.request({
    url: '/videoOpenClassType/getListAll',
    method: 'post',
    data: data
  });
};

// 视频分类管理 分页查询
var videoTypeList = exports.videoTypeList = function videoTypeList(data) {
  return _api.default.request({
    url: '/videoOpenClassType/getList',
    method: 'post',
    data: data
  });
};

// 视频分类管理 新增/编辑
var videoTypeUpload = exports.videoTypeUpload = function videoTypeUpload(data) {
  return _api.default.request({
    url: '/videoOpenClassType/insertOrUpdateVideoOpenClassType',
    method: 'post',
    data: data
  });
};

// 视频分类管理 删除
var videoTypeDelete = exports.videoTypeDelete = function videoTypeDelete(data) {
  return _api.default.request({
    url: '/videoOpenClassType/deleteVideoOpenClassType',
    method: 'post',
    data: data
  });
};